import { BaseRequest } from "../../BaseRequest";

export class UpdateFavouriteContextRequest extends BaseRequest{
    private folderId?:number;
    private projectId?:number;
    private activityId?:number;

    constructor(server: string, session: string, folderId?:number, projectId?:number, activityId?:number){
        super(server, session);
        this.folderId = folderId;
        this.projectId = projectId;
        this.activityId = activityId;
    }

    public toXml():string{
        var parameters = super.toXml();
        parameters += this.makeNode(this.folderId, 'folderId');
        parameters += this.makeNode(this.projectId, 'projectId');
        parameters += this.makeNode(this.activityId, 'activityId');

        return super.wrapperXml("UpdateFavouriteContext", parameters);
    }
}